import React, { useEffect, useState } from "react";
import { Platform, StyleSheet, View } from "react-native";
import StarButton from "./StarButton";
import { useTheme } from "react-native-paper";
import AppInput from "./AppInput";

interface RatingProps {
  value: number;
  setValue: (...event: any[]) => void;
  editable?: boolean;
  min?: number;
  max?: number;
}

export default function Rating({
  value,
  setValue,
  editable = true,
  min = 0,
  max = 5,
}: RatingProps) {
  const theme = useTheme();

  const [starsArray, setStarsArray] = useState<boolean[]>(Array(max).fill(false));

  const styles = stylesGen(theme);

  // WEB-APP HANDLER
  const getValueForWeb = (): number => {
    let value = 0;

    for (const stars of starsArray) {
      if (stars === true) {
        value++;
      }
    }

    return value;
  };

  const handleInputChange = (v: string) => {
    const numericValue = Number(v);
    if (!isNaN(numericValue)) {
      if (numericValue < min) {
        setValue(min);
      } else if (numericValue > max) {
        setValue(max);
      } else {
        setValue(numericValue);
      }
    }
  };
  // END WEB-APP HANDLER

  useEffect(() => {
    const updatedStarsArray = starsArray.map((_, idx) => idx < value);
    setStarsArray(updatedStarsArray);
  }, [value]);

  return (
    <View style={styles.row}>
      {Platform.OS !== "web" &&
        starsArray.map((boolValue, idx) => (
          <StarButton
            key={idx}
            nb={idx + 1}
            value={value}
            setValue={setValue}
            setStarsArray={setStarsArray}
            filled={boolValue}
            editable={editable}
          />
        ))}
      {Platform.OS === "web" && (
        <AppInput
          value={String(getValueForWeb())}
          onChangeText={handleInputChange}
          keyboardType="number-pad"
          editable={editable}
          placeholder={`Entre ${min === 0 ? 1 : min} et ${max}`}
        />
      )}
    </View>
  );
}

const stylesGen = (theme) =>
  StyleSheet.create({
    row: {
      width: "100%",
      justifyContent: "center",
      flexDirection: "row",
      borderWidth: 1,
      borderColor: theme.colors.tertiary,
      borderRadius: 20,
      padding: 10,
    },
  });
